import React, {Component} from 'react';
import {Button, Form, Icon, Input, Message, Popup} from 'semantic-ui-react';
import * as XLSX from 'xlsx';
import FormStyles from '../forms/form.module.css';
import Styles from './nuevaActividad.module.css';

const opcionesPago = [
	{key: 'unidad', value: 'unidad', text: 'unidad'},
	{key: 'metro', value: 'metro', text: 'metro'},
	{key: 'minuto', value: 'minuto', text: 'minuto'},
];

const encabezadosEsperados = [
	'nombre',
	'categoria',
	'pagar por',
	'precio minimo',
	'precio medio',
	'precio maximo',
];

const normalizarTexto = value => String(value || '')
	.trim()
	.toLowerCase()
	.normalize('NFD')
	.replace(/[\u0300-\u036f]/g, '');

class NuevaActividad extends Component{

	constructor(props){
		super(props);
		this.state = {
			nombre: '',
			categoria: '',
			precioMin: '',
			precioMid: '',
			precioMax: '',
			superficie: '',
			pagarpor: '',
			mostrarImportacion: false,
			importando: false,
			resultadoImportacion: null,
		};
		this.handleUserInput = this.handleUserInput.bind(this);
		this.writeNew = this.writeNew.bind(this);
		this.changeModal= this.props.changeModal;
		this.fileInput = React.createRef();
	}

	handleUserInput(event, {name, value}){
		this.setState({
			[name]: value
		})
	}

	writeNew(event){
		event.preventDefault();
		const data = this.state;
		this.props.addAct(data);
		this.setState({
			nombre: '',
			categoria: '',
			precioMin: '',
			precioMid: '',
			precioMax: '',
			pagarpor: ''
		})
		this.changeModal(false)
	}

	importarArchivo = async event => {
		const input = event.target;
		const file = input.files[0];
		if(!file) return;

		this.setState({importando: true, resultadoImportacion: null});
		try {
			const workbook = XLSX.read(await file.arrayBuffer(), {type: 'array'});
			const sheet = workbook.Sheets[workbook.SheetNames[0]];
			const rows = XLSX.utils.sheet_to_json(sheet, {header: 1, defval: ''});
			const headers = (rows[0] || []).slice(0, encabezadosEsperados.length).map(normalizarTexto);

			if(encabezadosEsperados.some((header, index) => headers[index] !== header)) {
				throw new Error('Los encabezados no coinciden con la plantilla. Descárgala y conserva sus columnas.');
			}

			const unidadesValidas = opcionesPago.map(option => option.value);
			const actividades = [];
			const filasInvalidas = [];
			const nombresDuplicados = [];
			const nombresExistentes = new Set(
				(this.props.actividades || []).map(actividad => normalizarTexto(actividad.nombre))
			);
			const nombresDelArchivo = new Set();

			rows.slice(1).forEach((row, index) => {
				const nombre = String(row[0] || '').trim();
				if(!nombre || normalizarTexto(nombre).startsWith('ejemplo:')) return;
				const nombreNormalizado = normalizarTexto(nombre);

				if(nombresExistentes.has(nombreNormalizado) || nombresDelArchivo.has(nombreNormalizado)) {
					nombresDuplicados.push(`${index + 2} (${nombre})`);
					return;
				}
				nombresDelArchivo.add(nombreNormalizado);

				const pagarpor = normalizarTexto(row[2]);
				const precios = [row[3], row[4], row[5]].map(value => Number(value));
				if(!unidadesValidas.includes(pagarpor) || precios.some(value => !Number.isFinite(value) || value < 0)) {
					filasInvalidas.push(index + 2);
					return;
				}

				actividades.push({
					nombre,
					categoria: String(row[1] || '').trim(),
					pagarpor,
					precioMin: precios[0],
					precioMid: precios[1],
					precioMax: precios[2],
				});
			});

			if(filasInvalidas.length) {
				throw new Error(`Corrige las filas ${filasInvalidas.join(', ')}: revisa la unidad de pago y los precios.`);
			}
			if(!actividades.length && !nombresDuplicados.length) {
				throw new Error('El archivo no contiene actividades para importar.');
			}

			await Promise.all(actividades.map(actividad => this.props.addAct(actividad)));
			const importadas = actividades.length;
			const duplicadas = nombresDuplicados.length;
			this.setState({
				resultadoImportacion: {
					success: true,
					text: `${importadas} ${importadas === 1 ? 'actividad importada' : 'actividades importadas'}; ${duplicadas} ${duplicadas === 1 ? 'duplicada ignorada' : 'duplicadas ignoradas'}.`,
				},
			});
		}
		catch(error) {
			this.setState({
				resultadoImportacion: {success: false, text: error.message || 'No fue posible leer el archivo.'},
			});
		}
		finally {
			this.setState({importando: false});
			input.value = '';
		}
	}

	render(){
		return(
			<div>
				<form className={FormStyles.form} onSubmit={this.writeNew}>
					<Form.Field className={FormStyles.fieldRow}>
						<label className={FormStyles.fieldLabel}>Actividad</label>
						<div className={FormStyles.fieldContent}>
							<Input fluid type='text' placeholder='Nombre único' name='nombre' required={true}
								onChange={this.handleUserInput} value={this.state.nombre} />
						</div>
					</Form.Field>

					<Form.Field className={FormStyles.fieldRow}>
						<label className={FormStyles.fieldLabel}>Categoría</label>
						<div className={FormStyles.fieldContent}>
							<Input fluid type='text' placeholder='Categoría' name='categoria'
								onChange={this.handleUserInput} value={this.state.categoria} />
						</div>
					</Form.Field>

					<Form.Field className={FormStyles.fieldRow}>
						<label className={FormStyles.fieldLabel}>Pagar por</label>
						<div className={FormStyles.fieldContent}>
							<Form.Dropdown placeholder='Selecciona una unidad' name='pagarpor' required={true}
								fluid selection options={opcionesPago} onChange={this.handleUserInput}
								value={this.state.pagarpor} />
						</div>
					</Form.Field>

					<Form.Field className={FormStyles.fieldRow}>
						<label className={`${FormStyles.fieldLabel} ${Styles.priceLabel}`}>
							Precios
							<Popup
								position='top center'
								content='Los tres precios permiten manejar tarifas distintas según la dificultad del trabajo. Si no necesitas variaciones, puedes poner el mismo valor en Mínimo, Medio y Máximo.'
								trigger={<Icon name='info circle' className={Styles.infoIcon} tabIndex='0' aria-label='Información sobre los precios' />}
							/>
						</label>
						<div className={`${FormStyles.fieldContent} ${Styles.priceGrid}`}>
							<div>
								<label className={FormStyles.subLabel}>Mínimo</label>
								<Input fluid type='number' step='any' placeholder='Pesos' name='precioMin'
									onChange={this.handleUserInput} value={this.state.precioMin} />
							</div>
							<div>
								<label className={FormStyles.subLabel}>Medio</label>
								<Input fluid type='number' step='any' placeholder='Pesos' name='precioMid'
									onChange={this.handleUserInput} value={this.state.precioMid} />
							</div>
							<div>
								<label className={FormStyles.subLabel}>Máximo</label>
								<Input fluid type='number' step='any' placeholder='Pesos' name='precioMax'
									onChange={this.handleUserInput} value={this.state.precioMax} />
							</div>
						</div>
					</Form.Field>

					{this.state.mostrarImportacion ?
						<div className={Styles.importPanel}>
							<div>
								<strong>Importar actividades desde Excel</strong>
								<p>Usa la plantilla para conservar las columnas y los valores permitidos.</p>
							</div>
							<div className={Styles.importOptions}>
								<Button as='a' basic href='/templates/plantilla-actividades.xlsx' download='plantilla-actividades.xlsx'>
									<Icon name='download' />Descargar plantilla
								</Button>
								<Button type='button' basic loading={this.state.importando} onClick={() => this.fileInput.current.click()}>
									<Icon name='file excel outline' />Seleccionar archivo
								</Button>
								<input ref={this.fileInput} className={Styles.fileInput} type='file' accept='.xls,.xlsx' onChange={this.importarArchivo} />
							</div>
							{this.state.resultadoImportacion ?
								<Message positive={this.state.resultadoImportacion.success} negative={!this.state.resultadoImportacion.success} size='small'>
									{this.state.resultadoImportacion.text}
								</Message>
							:null}
						</div>
					:null}

					<div className={FormStyles.actions}>
						<Button type='button' basic onClick={() => this.setState(state => ({mostrarImportacion: !state.mostrarImportacion, resultadoImportacion: null}))}>
							<Icon name='upload' />Importar
						</Button>
						<Button type='button' basic onClick={() => this.changeModal(false)}>Cancelar</Button>
						<Button type='submit' positive>Agregar</Button>
					</div>
				</form>

			</div>
		)
	}
}

export default NuevaActividad;
